var CarouselButtons = /** @class */ (function () {
    function CarouselButtons(carouselOptions) {
        var _this = this;
        var containerEl = carouselOptions.containerEl;
        this.buttonPrev = containerEl.querySelector('[data-id="button-prev"]');
        this.buttonNext = containerEl.querySelector('[data-id="button-next"]');
        if (!this.buttonPrev || !this.buttonNext)
            return;
        // prev button
        this.buttonPrev.addEventListener('mouseenter', function () {
            return _this.buttonPrevMouseEnter();
        });
        this.buttonPrev.addEventListener('mouseleave', function () {
            return _this.buttonPrevMouseLeave();
        });
        this.buttonPrev.addEventListener('click', function () {
            return _this.buttonPrevMouseClick();
        });
        // next button
        this.buttonNext.addEventListener('mouseenter', function () {
            return _this.buttonNextMouseEnter();
        });
        this.buttonNext.addEventListener('mouseleave', function () {
            return _this.buttonNextMouseLeave();
        });
        this.buttonNext.addEventListener('click', function () {
            return _this.buttonNextMouseClick();
        });
    }
    CarouselButtons.prototype.showNextButton = function (bool) {
        var _a, _b;
        if (bool) {
            (_a = this.buttonNext) === null || _a === void 0 ? void 0 : _a.classList.remove('hide');
        }
        else {
            (_b = this.buttonNext) === null || _b === void 0 ? void 0 : _b.classList.add('hide');
        }
    };
    CarouselButtons.prototype.showPrevButton = function (bool) {
        var _a, _b;
        if (bool) {
            (_a = this.buttonPrev) === null || _a === void 0 ? void 0 : _a.classList.remove('hide');
        }
        else {
            (_b = this.buttonPrev) === null || _b === void 0 ? void 0 : _b.classList.add('hide');
        }
    };
    CarouselButtons.prototype.buttonPrevMouseEnter = function () {
        var _a;
        (_a = this.buttonPrev) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-clicked');
        // call method from child class
    };
    CarouselButtons.prototype.buttonPrevMouseLeave = function () {
        // to prevent ts error
        // call method from child class
    };
    CarouselButtons.prototype.buttonPrevMouseClick = function () {
        var _a;
        (_a = this.buttonPrev) === null || _a === void 0 ? void 0 : _a.setAttribute('data-clicked', 'true');
        // call method from child class
    };
    CarouselButtons.prototype.buttonNextMouseEnter = function () {
        var _a;
        (_a = this.buttonNext) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-clicked');
        // call method from child class
    };
    CarouselButtons.prototype.buttonNextMouseLeave = function () {
        // to prevent ts error
        // call method from child class
    };
    CarouselButtons.prototype.buttonNextMouseClick = function () {
        var _a;
        (_a = this.buttonNext) === null || _a === void 0 ? void 0 : _a.setAttribute('data-clicked', 'true');
        // call method from child class
    };
    return CarouselButtons;
}());
export default CarouselButtons;
